import reactEnv from '@beam-australia/react-env';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    __ENV: Record<string, string>;
  }
}

/**
 * When the app runs with Cypress, reactEnv function is undefined initially.
 * This is a fix to prevent Cypress from crashing.
 */
const env = (key: string): string | undefined => {
  if (reactEnv) {
    return reactEnv(key);
  }

  const safeKey = `REACT_APP_${key}`;
  if (typeof window !== 'undefined') {
    return window.__ENV[safeKey];
  } else {
    return process.env[safeKey];
  }
};

export const nodeEnv = process.env['NODE_ENV'];

type ReleaseEnv = 'staging' | 'preprod' | 'prod';
export const releaseEnv: ReleaseEnv = (env('ALGOAN_ENV') as ReleaseEnv | undefined) ?? 'preprod';

export const apiUrl = env('API_URL') ?? 'https://api.preprod.algoan.com';

export const amplitudeApiKey = env('AMPLITUDE_API_KEY') ?? '';

export const enableMockServer = env('MOCK_SERVER') === 'true';

export const resetPasswordUrl =
  env('RESET_PASSWORD_URL') ?? 'https://auth.dev.algoan.net/auth/realms/algoan/login-actions/reset-credentials';

export const authClientId = 'dashboard-webapp';

export const authUrl = env('ALGOAN_AUTH_URL') ?? 'https://auth.preprod.algoan.com/auth/realms/algoan';

export const authRoute = '/v1/oauth/token';

export const tgglApiKey = env('TGGL_API_KEY') ?? 'NNmG6bsvch4zuiKkmJhS3ho0VBn7fHkWRb7ePvtvw9A';

export const datadogService = process.env['DD_SERVICE'] || 'dashboardwebapp';

export const datadogEnv = process.env['DD_ENV'] || 'algoan-preprod';

export const logLevel = process.env['LOG_LEVEL'] || 'info';
